// extracted by mini-css-extract-plugin
export var layout = "Footer-module--layout--bb888";
export var socialWrapper = "Footer-module--socialWrapper--8d0ff";
export var offices = "Footer-module--offices--1853b";
export var officeItem = "Footer-module--officeItem--a34fe";
export var officeTitle = "Footer-module--officeTitle--625f4";
export var officeDescription = "Footer-module--officeDescription--44551";
export var officeLink = "Footer-module--officeLink--2b7d3";
export var officeLinkWrapper = "Footer-module--officeLinkWrapper--939a8";
export var companyLinks = "Footer-module--companyLinks--d049d";